import { FunctionComponent, ReactNode, useState } from "react";
import { buildStyles, CircularProgressbarWithChildren } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import * as Styled from "./styles";
import {
  COLOR_DEEP_FOREST,
  COLOR_GRAY_GREEN,
  COLOR_GRAY_GREEN_2,
  COLOR_MANIFEST_TEAL,
} from "../../styles/globalStylesVariables";
import IconButton from "../icon-button";
import { Chevron } from "../icons";
import { CHEVRON_ORIENTATION_DOWN, CHEVRON_ORIENTATION_UP } from "../icons/constants";

interface TransferStatusTileProps {
  from: string;
  to: string;
  description: string;
  status: {
    progress: number;
    title: string;
    icon: ReactNode;
    disabled?: boolean;
  };
}

const TransferStatusTile: FunctionComponent<TransferStatusTileProps> = ({
  from,
  to,
  status,
  description,
}: TransferStatusTileProps) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  return (
    <Styled.TileContainer>
      <Styled.TileContent>
        <Styled.TileProgressContainer>
          <Styled.TileProgressBarContainer>
            <CircularProgressbarWithChildren
              strokeWidth={12}
              value={status.progress}
              styles={buildStyles({
                pathColor: status.disabled ? COLOR_GRAY_GREEN : COLOR_MANIFEST_TEAL,
                trailColor: COLOR_GRAY_GREEN_2,
              })}
            >
              {status.icon}
            </CircularProgressbarWithChildren>
          </Styled.TileProgressBarContainer>
        </Styled.TileProgressContainer>
        <Styled.TileContentMain>
          <div>
            <span className="text-gray tile-label">From</span>
            <span className="text-medium text-deep-forest tile-value">{from}</span>
          </div>
          <div>
            <span className="text-gray tile-label">To</span>
            <span className="text-medium text-deep-forest tile-value">
              {to}{" "}
              {(status.title === "Pending TRAD Destination Account" ||
                status.title.includes("Pending") ||
                status.title === "Pending Destination Account" ||
                status.title === "Pending Roth Destination Account" ||
                status.title === "Additional Information needed") &&
                "(Pending)"}
            </span>
          </div>
        </Styled.TileContentMain>
      </Styled.TileContent>
      <Styled.StatusContent $isExpanded={isExpanded}>
        <Styled.StatusContentHeader>
          <span
            className={`${status.disabled ? "text-error" : "text-manifest-teal"} tile-status-label`}
            data-name="transfer-status-tile-label"
            data-testid="transfer-status-tile-label"
          >
            Status
          </span>
          <span
            className="text-deep-forest tile-status-value"
            data-name="transfer-status-tile-status"
            data-testid="transfer-status-tile-status"
          >
            {status.title}
          </span>
          <IconButton name={"expand-icon"} onClick={() => setIsExpanded(!isExpanded)}>
            <Chevron
              orientation={isExpanded ? CHEVRON_ORIENTATION_UP : CHEVRON_ORIENTATION_DOWN}
              height={11}
              color={COLOR_DEEP_FOREST}
            />
          </IconButton>
        </Styled.StatusContentHeader>
        <Styled.StatusContentDetails $isExpanded={isExpanded}>
          <p>{description}</p>
        </Styled.StatusContentDetails>
      </Styled.StatusContent>
    </Styled.TileContainer>
  );
};

export default TransferStatusTile;
